import flowRight from 'lodash/flowRight';

import { RouteItemType } from '~/core/router';
import {
  withMainSimpleLayout,
  withMainSimpleLayoutNoSidebar,
  withOnboardingLayout,
} from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import {
  CancellationPath,
  getCancellationTitle,
} from '~/modules/cancellation/constants';

const Cancellation = lazyComponentLoader(() => import('./views'));
const PolyLLMCancellation = lazyComponentLoader(
  () => import('./views/variants/polyllm'),
);

export const CancellationRoute: RouteItemType = {
  Component: flowRight(
    withOnboardingLayout,
    withMainSimpleLayout,
  )(Cancellation),
  path: CancellationPath,
  getTitle: getCancellationTitle,
};

export const CancellationRoutePolyllmChat: RouteItemType = {
  Component: flowRight(
    withOnboardingLayout,
    withMainSimpleLayoutNoSidebar,
  )(PolyLLMCancellation),
  path: CancellationPath,
  getTitle: getCancellationTitle,
};
